<template>
  <div class="card border position-relative" :class="index == 0 ?'bg-light':''">
    <button
      class="btn btn-default btn-sm rounded-0 border-0"
      @click="$emit('remover', index)"
      v-if="unidade.tecnico_id == null && index > 0"
      style="position: absolute; top: 0; right: 0; color: #f30; z-index: 9999"
      title="Remover"
    >
      <i class="fas fa-times"></i>
    </button>

    <div class="card-body p-3">
      <div class="row">
        <form-select
          grid="6"
          v-model="unidade.unidade_id"
          :itens="unidades"
          :loading="$parent.loadingSearchUnidade"
          :disabled="
            $parent.loadingSearchUnidade ||
            index == 0 ||
            verifyKeyExist(unidade, 'id')
          "
          :required="true"
          placeholder="Pesquise o nome de uma Unidade."
          label="Unidade"
          v-if="unidade.unidade_id != 1"
        />
        <h4 v-else class="col-12">UNIDADE: Gestora do Sistema</h4>
        <form-select
          grid="6"
          v-model="unidade.funcao_unidade"
          :itens="roles"
          :required="true"
          placeholder="Selecione uma Função"
          label="Função na Unidade/Sistema"
          :disabled="$parent.disabledRole"
          v-if="unidade.funcao_unidade != 1"
        />
        <h4 v-else class="col-12">FUNÇÃO: Administradora</h4>
      </div>
      <div class="row">
        <form-select
          :grid="verifyKeyExist(unidade, 'id') ? '6' : '4'"
          v-model="unidade.regime_trabalho"
          :itens="$root.arrays.regimeTrabalhoTecnicos"
          placeholder="Selecione"
          label="Regime de Trabalho"
        />

        <form-calendar
          v-model="unidade.data_admissao"
          :grid="verifyKeyExist(unidade, 'id') ? '6' : '4'"
          label="Data de Vinculação"
        />

        <form-calendar
          v-model="unidade.data_desvinculacao"
          :grid="verifyKeyExist(unidade, 'id') ? '6' : '4'"
          label="Data de Desvinculação"
        />

        <form-select
          v-model="unidade.status"
          label="Status"
          grid="6"
          :itens="[
            { id: 1, value: 'ATIVO' },
            { id: 2, value: 'INATIVO' },
          ]"
          ajuda="A atualização deste campo para (INATIVO) bloqueia o acesso do técnico a unidade relacionada"
          v-if="verifyKeyExist(unidade, 'id')"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["unidade", "unidades", "roles", "disabledRole", "index"],
  data() {
    return {};
  },
  methods: {
    verifyKeyExist(model, indice) {
      return Object.keys(model).some((key) => key === indice);
    },
  },
};
</script>
